'use client';

import Image from 'next/image';
import React from "react";
import {useAppDispatch, useAppSelector} from "@/lib/redux/hooks";
import {close, open, selectIsOpen} from "@/lib/redux/slices/menuSlice";
import {selectIsOnNftPage} from "@/lib/redux/slices/nftPageSlice";
import {useRouter} from "next/navigation";

export default function HeaderMobile() {
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector(selectIsOpen);
    const isOnNftPage = useAppSelector(selectIsOnNftPage);
    const router = useRouter();

    const handleClose = (e: React.MouseEvent) => {
        e.stopPropagation();
        dispatch(close());
    };

    const handleOpen = (e: React.MouseEvent) => {
        e.stopPropagation();
        dispatch(open());
    };

    const handleRouteHome = (e: React.MouseEvent) => {
        e.stopPropagation();
        dispatch(close());
        router.push('/', {scroll: false});
    }

    const handleBack = (e: React.MouseEvent) => {
        e.stopPropagation();
        router.push('/', {scroll: false});
    }

    return (
        <header
            className="flex items-center justify-between w-full h-(--header-height-mobile) px-3 bg-dark-04 border-b border-grey-02">
            <div className={`relative transition-all duration-300 overflow-hidden ${!isOnNftPage && isOpen ? 'w-0' : 'w-10'} h-10`}>
                <button
                    className={`absolute inset-0 flex items-center justify-center transition-all duration-300 ${isOnNftPage ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
                    onClick={handleBack}
                    type="button"
                    aria-label="Go back"
                >
                    <Image
                        src='/icons/icon-arrow.svg'
                        alt='Back'
                        width={10}
                        height={19}
                        priority
                    />
                </button>
                <button
                    className={`absolute inset-0 flex items-center justify-center transition-all duration-300 ${!isOnNftPage ? (isOpen ? 'opacity-0 pointer-events-none' : 'opacity-100 pointer-events-auto') : 'opacity-0 pointer-events-none'}`}
                    onClick={handleOpen}
                    type="button"
                    aria-label="Open menu"
                >
                    <Image
                        src='/icons/icon-hamburger.svg'
                        alt='Menu'
                        width={25}
                        height={22}
                        priority
                    />
                </button>
            </div>

            <div className={`flex-1 flex transition-all duration-300 ${!isOnNftPage && isOpen ? 'justify-start' : 'justify-center'}`}>
                <button
                    className="flex items-center justify-center"
                    onClick={handleRouteHome}
                >
                    <Image
                        src='/logo.png'
                        alt='Dreissigacker Wein'
                        width={280}
                        height={26}
                        priority
                    />
                </button>
            </div>

            {/* Right side buttons */}
            <div className="relative w-10 h-10">
                {!isOnNftPage && (
                    <button
                        className={`absolute inset-0 flex items-center justify-center bg-dark-04 border border-white rounded-full transition-opacity ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                        onClick={handleClose}
                        type="button"
                        aria-label="Close menu"
                    >
                        <Image
                            src='/icons/icon-close.svg'
                            alt='Close'
                            width={22}
                            height={30}
                            priority
                        />
                    </button>
                )}
                <div></div>
            </div>
        </header>
    );
}